import { ComboBox, TextField } from "@fluentui/react";
import { PanelGenerico } from "../../../components/generic/PanelGenerico";
import { IHeaderTitlesText } from "../../../Interfaces/IPanel";
import HelpersIpercBase from "../../../utils/helpers/HelpersIpercBase";

interface INuevoProceso {
    isOpen: boolean
    onDismiss: ((ev?: React.SyntheticEvent<HTMLElement, Event> | KeyboardEvent | undefined) => void)
}

const HeaderPanelTiles: IHeaderTitlesText = {
    title: 'Nuevo Proceso',
    subTitle: 'Complete los campos para registar porceso',
}

function NuevoProceso(props: INuevoProceso) {

    return (
        <PanelGenerico
            isOpen={props.isOpen}
            onDismiss={props.onDismiss}
            disabledRegister
            enabledHeader
            HeaderTitlesText={HeaderPanelTiles}
            iconHeaderName='ProcessMetaTask'
            enabledIconHeader={false}
        >
            <br />
            <br />
            <div className="ms-Grid-col ms-lg12">
                <br />
                <TextField
                    {...HelpersIpercBase.TextTextFieldElevation}
                    placeholder="Nombre de Proceso *"
                />
            </div>
            <div className="ms-Grid-col ms-lg12">
                <br />
                <ComboBox
                    // componentRef={comboBoxRef}
                    useComboBoxAsMenuWidth
                    allowFreeform
                    calloutProps={{ directionalHintFixed: true }}
                    scrollSelectedToTop
                    autoComplete="off"
                    label="Gerencia"
                    options={[]}
                />
            </div>
            <div className="ms-Grid-col ms-lg12">
                <br />
                <ComboBox
                    // componentRef={comboBoxRef}
                    useComboBoxAsMenuWidth
                    allowFreeform
                    calloutProps={{ directionalHintFixed: true }}
                    scrollSelectedToTop
                    autoComplete="off"
                    label="Area"
                    options={[]}
                />
            </div>
        </PanelGenerico>
    );
}

export default NuevoProceso;